import React from "react";
import { Link } from "react-router-dom";
import DeliveryTimeAdd from "./DeliveryTimeAdd";

class DeliveryTimeAddTab extends React.Component {
  state = {};

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4> Delivery Time </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i> </Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Delivery Time
                  </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">

                    <div className="tab-content tabs">
                      <div className="tab-pane active" role="tabpanel" aria-labelledby="">

                        <DeliveryTimeAdd goBack={this.props.history.goBack} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeliveryTimeAddTab;
